/* eslint-disable */ import { AjvReflection, DomainEntityReflection, EnumReflection, RawAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
export const modelVersion = 1;
export const Liner = new EnumReflection('Liner', {
    type: 'string',
    enum: [
        'none',
        'mesh',
        'compression'
    ]
});
export const Fabric = new EnumReflection('Fabric', {
    type: 'string',
    enum: [
        '90/10 stretch',
        '96/4 stretch',
        'tan through'
    ]
});
export const Size = new EnumReflection('Size', {
    type: 'string',
    enum: [
        'xs',
        's',
        'm',
        'l',
        'xl',
        '2xl',
        '3xl'
    ]
});
export const Inseam = new AjvReflection('Inseam', {
    type: 'number',
    enum: [
        -0.5,
        0,
        0.5
    ]
});
const WithDesignShape = new AjvReflection('WithDesignShape', {
    type: 'object',
    properties: {
        collection: {
            type: 'string'
        },
        design: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'collection',
        'design'
    ]
});
const ShortsShape = new AjvReflection('ShortsShape', {
    type: 'object',
    properties: {
        liner: Liner._meta.schema,
        fabric: Fabric._meta.schema,
        size: Size._meta.schema,
        inseam: Inseam._meta.schema
    },
    additionalProperties: false,
    required: [
        'liner',
        'fabric',
        'size',
        'inseam'
    ]
});
const DrawstringShape = new AjvReflection('DrawstringShape', {
    type: 'object',
    properties: {
        color: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'color'
    ]
});
export const SwimShorts = new DomainEntityReflection('SwimShorts', [
    ShortsShape._meta.schema,
    WithDesignShape._meta.schema
]);
export const BoardShorts = new DomainEntityReflection('BoardShorts', [
    ShortsShape._meta.schema,
    WithDesignShape._meta.schema
]);
export const VolleyballShorts = new DomainEntityReflection('VolleyballShorts', [
    ShortsShape._meta.schema,
    WithDesignShape._meta.schema
]);
export const LeftLeg = new DomainEntityReflection('LeftLeg', [
    WithDesignShape._meta.schema
]);
export const RightLeg = new DomainEntityReflection('RightLeg', [
    WithDesignShape._meta.schema
]);
export const LeftThighBand = new DomainEntityReflection('LeftThighBand', [
    WithDesignShape._meta.schema
]);
export const RightThighBand = new DomainEntityReflection('RightThighBand', [
    WithDesignShape._meta.schema
]);
export const Waistband = new DomainEntityReflection('Waistband', [
    WithDesignShape._meta.schema
]);
export const Drawstring = new DomainEntityReflection('Drawstring', [
    DrawstringShape._meta.schema
]);
export const AnyDomainEntity = new RawAliasReflection('AnyDomainEntity', [
    SwimShorts,
    BoardShorts,
    VolleyballShorts,
    LeftLeg,
    RightLeg,
    LeftThighBand,
    RightThighBand,
    Waistband,
    Drawstring
]);
export const SunlifeShorts = new RawAliasReflection('SunlifeShorts', [
    SwimShorts,
    BoardShorts,
    VolleyballShorts
]);
export const Shorts = new RawAliasReflection('Shorts', [
    ...SunlifeShorts.reflections
]);
export const PartsWithDesign = new RawAliasReflection('PartsWithDesign', [
    LeftLeg,
    RightLeg,
    LeftThighBand,
    RightThighBand,
    Waistband
]);
export const WithDesign = new RawAliasReflection('WithDesign', [
    ...Shorts.reflections,
    ...PartsWithDesign.reflections
]);
export const Part = new RawAliasReflection('Part', [
    LeftLeg,
    RightLeg,
    LeftThighBand,
    RightThighBand,
    Waistband,
    Drawstring
]);
export const RootEntity = new RawAliasReflection('RootEntity', [
    ...Shorts.reflections
]);
export const ThighBand = new RawAliasReflection('ThighBand', [
    LeftThighBand,
    RightThighBand
]);
export const aliases = {
    AnyDomainEntity: AnyDomainEntity.types,
    SunlifeShorts: SunlifeShorts.types,
    Shorts: Shorts.types,
    PartsWithDesign: PartsWithDesign.types,
    WithDesign: WithDesign.types,
    Part: Part.types,
    RootEntity: RootEntity.types,
    ThighBand: ThighBand.types
};
export const entities = {
    SwimShorts,
    BoardShorts,
    VolleyballShorts,
    LeftLeg,
    RightLeg,
    LeftThighBand,
    RightThighBand,
    Waistband,
    Drawstring
};

//# sourceMappingURL=v1.js.map